import { Avatar } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { ShieldCheck } from 'lucide-react';

const STATUS_TEXT = {
  confirmed: 'text-emerald-500',
  pending: 'text-amber-500',
  denied: 'text-rose-500',
};

/**
 * Two-key gate — prototype: colored status under the name (no right-side badges).
 */
function ApproverStatusBlock({ approvers = [], confirmedCount, requiredCount, granted }) {
  const { t } = useTranslation('work-queues-app');

  return (
    <div>
      <div className="flex items-center justify-between gap-3">
        <p className="text-xs font-semibold uppercase tracking-wide text-content-faint">
          {t('breakGlass.approverStatus')}
        </p>
        {granted ? (
          <span className="inline-flex items-center gap-1.5 text-sm font-medium text-emerald-500">
            <ShieldCheck size={16} />
            {t('breakGlass.accessGranted')}
          </span>
        ) : (
          <span className="text-sm text-content-muted">
            {t('breakGlass.confirmedCount', { count: confirmedCount, total: requiredCount })}
          </span>
        )}
      </div>

      <div className="mt-3 flex flex-col gap-3">
        {approvers.map((approver) => (
          <div key={approver.id} className="flex items-center gap-2.5">
            <Avatar size="sm" initials={approver.initials} alt={approver.name} />
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium text-content">{approver.name}</p>
              <p className={['text-xs font-medium', STATUS_TEXT[approver.status] ?? 'text-content-faint'].join(' ')}>
                {approver.status === 'confirmed' && approver.confirmedAt
                  ? `${t('breakGlass.status.confirmed')} · ${approver.confirmedAt}`
                  : t(`breakGlass.status.${approver.status}`, { defaultValue: approver.role })}
              </p>
            </div>
          </div>
        ))}
      </div>

      {!granted && (
        <p className="mt-3 text-xs text-content-faint">{t('breakGlass.twoKeyHint')}</p>
      )}
    </div>
  );
}

export default ApproverStatusBlock;
